/**
 * Frontend mirror of backend `_is_pro`. Kept simple: any component can
 * check `isPro(user)` without importing AuthContext plumbing.
 */

const PRO_TIERS = new Set(["pjp_pro", "charter_operator", "charter_client", "empty_leg_rider"]);

export function isPro(user) {
  if (!user) return false;
  if (user.founding_member) return true;
  if (user.is_admin) return true;
  if (user.membership_status === "active" && PRO_TIERS.has(user.membership_tier_slug)) return true;
  return false;
}
